import { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  ResponsiveContainer,
  CartesianGrid,
  Tooltip,
  YAxis,
} from "recharts";
import EditAgeDistributionModal from "./EditAgeDistributionModal";
import { callApi } from "../../services/ApiServices";
import { useGlobalStates } from "../../utlis/ClubsContext";
import { UserRole } from "../../utlis/constant";

const AgeDistributionChart = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [chartData, setChartData] = useState([
    { age: "Under age 18", value: 10 },
    { age: "18 - 24", value: 35 },
    { age: "25-34", value: 25 },
    { age: "35-44", value: 42 },
    { age: "45-54", value: 50 },
    { age: "55-64", value: 12 },
    { age: "Age65+", value: 30 },
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const { selectedClub, handleSelectedClubDetail, userRole } = useGlobalStates();
  console.log("selectedClub", selectedClub);

  useEffect(() => {
    setChartData([
      { age: "Under age 18", value: selectedClub?.avgDistribUnd18 || 0 },
      { age: "18 - 24", value: selectedClub?.avgDistrib18_24 || 0 },
      { age: "25-34", value: selectedClub?.avgDistrib25_34 || 0 },
      { age: "35-44", value: selectedClub?.avgDistrib35_44 || 0 },
      { age: "45-54", value: selectedClub?.avgDistrib45_54 || 0 },
      { age: "55-64", value: selectedClub?.avgDistrib55_64 || 0 },
      { age: "Age65+", value: selectedClub?.avgDistribOver65 || 0 },
    ]);
  }, [selectedClub]);
  const handleCloseModal = () => {
    setIsEditing(false);
  };

  const handleSaveModal = async (data) => {
    try {
      setIsLoading(true);
      const res = await callApi({
        method: "put",
        url: `club/update/${selectedClub?.id}`,
        data: {
          fields: {
            avgDistribUnd18: data.underAge18,
            avgDistrib18_24: data.age18to24,
            avgDistrib25_34: data.age25to34,
            avgDistrib35_44: data.age35to44,
            avgDistrib45_54: data.age45to54,
            avgDistrib55_64: data.age55to64,
            avgDistribOver65: data.age65plus,
          },
        },
      });
      console.log("age respo", res);
      if (res.status === 200) {
        handleSelectedClubDetail(selectedClub);
      }
    } catch (error) {
      console.log("save age distribution error", error);
    } finally {
      setIsLoading(false);
    }
    setIsEditing(false);
  };
  return (
    <>
      <div className="bg-[#F7FBFC] border border-[#d8ebee] rounded-xl p-6 main-shadow h-full">
        <div className="flex items-center justify-between gap-3 mb-6">
          <h2 className="text-xl md:text-xl font-medium text-black leading-tight">
            Age Breakdown of Visitors
          </h2>
          <div className="flex items-center gap-2">
            <span className="px-3 py-1 rounded-full bg-[#e7f3f6] text-[#157182] text-sm font-semibold whitespace-nowrap">
              {(selectedClub?.clubTotalMembers || 0).toLocaleString()} Members
            </span>
            <button
              onClick={() => setIsEditing(true)}
              disabled={userRole === UserRole.Viewer}
              className={`flex items-center ${
                userRole === UserRole.Viewer
                  ? "cursor-not-allowed opacity-50"
                  : "cursor-pointer hover:bg-[#e7f3f6]"
              } gap-1 text-sm font-medium text-[#145463] px-2 py-1 rounded-md transition-colors`}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.333 2.00004C11.5081 1.82494 11.716 1.68605 11.9447 1.59129C12.1735 1.49653 12.4187 1.44775 12.6663 1.44775C12.914 1.44775 13.1592 1.49653 13.3879 1.59129C13.6167 1.68605 13.8246 1.82494 13.9997 2.00004C14.1748 2.17513 14.3137 2.383 14.4084 2.61178C14.5032 2.84055 14.552 3.08575 14.552 3.33337C14.552 3.58099 14.5032 3.82619 14.4084 4.05497C14.3137 4.28374 14.1748 4.49161 13.9997 4.66671L4.99967 13.6667L1.33301 14.6667L2.33301 11L11.333 2.00004Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Edit
            </button>
          </div>
        </div>

        <div className="h-[240px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={chartData}
              margin={{ top: 10, right: 4, left: 4, bottom: 10 }}
              barCategoryGap="6%"
            >
              <defs>
                <linearGradient id="ageBarGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#28998B" />
                  <stop offset="100%" stopColor="#1B7D7C" />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="0" vertical={false} stroke="#e8f0f2" />
              <XAxis
                dataKey="age"
                axisLine={false}
                tickLine={false}
                tick={{ fill: "#4e5f66", fontSize: 12 }}
                interval={0}
              />
              <YAxis
                hide
                domain={[0, 100]}
              />
              <Tooltip
                formatter={(value) => [`${value}%`, "Visitors"]}
                labelFormatter={(label) => `Age: ${label}`}
              />
              <Bar dataKey="value" radius={[8, 8, 0, 0]} barSize={85} fill="url(#ageBarGradient)" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      {isEditing && (
        <EditAgeDistributionModal
          onClose={handleCloseModal}
          onSave={handleSaveModal}
          initialData={{
            underAge18: selectedClub?.avgDistribUnd18 || "",
            age18to24: selectedClub?.avgDistrib18_24 || "",
            age25to34: selectedClub?.avgDistrib25_34 || "",
            age35to44: selectedClub?.avgDistrib35_44 || "",
            age45to54: selectedClub?.avgDistrib45_54 || "",
            age55to64: selectedClub?.avgDistrib55_64 || "",
            age65plus: selectedClub?.avgDistribOver65 || "",
          }}
          isLoading={isLoading}
        />
      )}
    </>
  );
};

export default AgeDistributionChart;
